export default "__VITE_ASSET__7_y0_k0b__"